import { useSession } from "next-auth/react";

/**
 * Hook para obter dados do usuário atual com status da sessão
 * Retorna objeto com user, status e flags de loading/autenticação
 */
export const useCurrentUserWithStatus = () => {
    const { data: session, status } = useSession();

    return {
        user: session?.user,
        status, // "loading" | "authenticated" | "unauthenticated"
        isLoading: status === "loading",
        isAuthenticated: status === "authenticated",
    };
};

/**
 * Hook simplificado para obter apenas o usuário (compatibilidade)
 * Retorna user ou undefined
 */
export const useCurrentUser = () => {
    const { data: session } = useSession();
    return session?.user;
};

